const actions = {

  updateWindowWidth({commit}, width) {
    commit('UPDATE_WINDOW_WIDTH', width);
  },

  // SIDEBAR & UI UX
  updateSidebarWidth({commit}, width) {
    commit('UPDATE_SIDEBAR_WIDTH', width);
  },


  UPDATE_SIDEBAR_MIN({commit}, is_min = null) {
    let isMin = false;

    if (is_min === null) {
      isMin = localStorage.sidebarMinimized === 'true';
    } else {
      localStorage.sidebarMinimized = is_min;
      isMin = is_min;
    }

    commit('SET_SIDEBAR_MIN', isMin);
  },
  UPDATE_SIDEBAR_ACTIVE({commit}, isActive = false) {
    commit('SET_SIDEBAR_ACTIVE', isActive);
  },
  UPDATE_SIDEBAR_MOBILE({commit, getters, dispatch}, is_mobile = null) {
    let isMobile = false;
    if (is_mobile === null) {
      if (getters.windowWidth <= 992) {
        isMobile = true;
      }
    } else {
      isMobile = is_mobile
    }
    if (!isMobile) {
      dispatch('UPDATE_SIDEBAR_ACTIVE', false);
    }
    commit('SET_SIDEBAR_MOBILE', isMobile);
  },
  UPDATE_HIGH_CONTRAST({commit}, is_contrast = null) {
    let isContrast = false;
    if (is_contrast === null) {
      isContrast = localStorage.appHighContrast === 'true';
    } else {
      localStorage.appHighContrast = is_contrast;
      isContrast = is_contrast;
    }
    commit('SET_HIGH_CONTRAST', isContrast);
  },
  UPDATE_APP_FONT_LARGER({commit}, is_larger = null) {
    let isLarger = false;
    if (is_larger === null) {
      isLarger = localStorage.appFontLarger === 'true';
    } else {
      localStorage.appFontLarger = is_larger;
      isLarger = is_larger;
    }
    commit('SET_LARGER_FONT', isLarger);
  }
};

export default actions
